export default __webpack_public_path__ + "static/media/APC-Assembly-Blurr.59ab2f13.jpg";